// libs
import React, { memo, useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';

// helpers
import { getRecentViewedPDP, addRecentViewedPDP, removeRecentViewedPDP } from './helpers';

interface IRecentlyViewedObserverProps {
  data: ProductDetail.IProduct;
  productID: string;
  isOutOfStock: boolean;
  storeId: string;
}

function RecentlyViewedObserver({ data, productID, isOutOfStock, storeId }: IRecentlyViewedObserverProps) {
  useEffect(() => {
    const pdpData = getRecentViewedPDP().filter(
      (item: ProductDetail.IProduct) => item.id === productID
    );

    // pdp is oos and also not available in recent searches
    // no action required
    if (isEmpty(pdpData) && isOutOfStock) {
      return;
    }

    if (!isEmpty(pdpData) && isOutOfStock) {
      removeRecentViewedPDP(productID);
      return;
    }

    if (!isOutOfStock) {
      addRecentViewedPDP(data, storeId);
    }
  }, [data, isOutOfStock, productID, storeId]);

  return <></>;
}

export default memo(RecentlyViewedObserver);
